import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menuStatisticsCenter",
  "use": "icon-menuStatisticsCenter-usage",
  "viewBox": "-100 -100 1224 1224",
  "content": "<symbol class=\"icon\" viewBox=\"-100 -100 1224 1224\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menuStatisticsCenter\"><path d=\"M640 832v64h192v128H192v-128h192v-64H0V0h1024v832h-384z m256-704H128v576h768V128zM320 384H192V256h128v128z m0 192H192V448h128v128z m512-192H384V256h448v128z m0 192H384V448h448v128z\" p-id=\"17550\" fill=\"#334681\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menuStatisticsCenter.svg
// module id = zDVM
// module chunks = 111